import apiClient from './client';

export interface LoginDto {
  loginIdentifier: string; // email or username
  password: string;
}

export interface AuthResponse {
  access_token: string;
  refresh_token: string;
  user: {
    id: string;
    email: string | null;
    username: string;
    firstName: string | null;
    lastName: string | null;
    role: 'user' | 'admin';
    is_anonymous: boolean;
    isSubscribed: boolean;
    subscribedEnd: Date | null;
  };
}

export const authApi = {
  login: async (credentials: LoginDto): Promise<AuthResponse> => {
    const response = await apiClient.post<AuthResponse>('/auth/login', credentials);
    return response.data;
  },

  getCurrentUser: async (): Promise<AuthResponse> => {
    const response = await apiClient.get<AuthResponse>('/auth/me');
    return response.data;
  },

  refreshToken: async (): Promise<{ access_token: string; refresh_token: string }> => {
    // Backend reads refresh token from httpOnly cookie. Empty body is fine.
    const response = await apiClient.post<{ access_token: string; refresh_token: string }>('/auth/refresh', {});
    return response.data;
  },

  logout: async (): Promise<void> => {
    await apiClient.post('/auth/logout', {});
  },
};

